import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { InformesService } from 'app/services/informes.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { BenefXTitularComponent } from './benef-x-titular/benef-x-titular.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-info-contrato',
  templateUrl: './info-contrato.component.html',
  styleUrls: ['./info-contrato.component.scss']
})
export class InfoContratoComponent implements OnInit {

  //DataTable
  public dtOption;
  public tableOpt;
  @ViewChild(DataTableDirective, {static:true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>;
  

  constructor(@Inject(MAT_DIALOG_DATA) private data, private _informe: InformesService, private dialog: MatDialog, private _snackBar: MatSnackBar) {
    this.dtTrigger = new Subject();
    this.dtTrigger.next();
    
    this.tableOpt = [];
    this.dtOption = {
      columns: [
        {
          title: ''
        },
        {
          title: 'Promedio Servicios',
          render: (data,type,row,meta) => {
            if( row.servicio_adecuado == 0) {
              data = 0;
            }else{
              data = (data / row.servicio_adecuado);
            }
            return (data).toFixed(2)+'%';
          }
        },
        {
          title: 'Total Servicios',
          data: 'total_servicios'
        },
        {
          title: 'N° Beneficiarios',
          data: 'beneficiarios'
        },
        {
          title: 'PSM',
          data: 'psm'
        },
        {
          title: 'SAT',
          data: 'servicio_adecuado'
        },
        {
          title: 'Documento',
          data: 'titnit'
        },
        {
          title: 'Nombre',
          data: 'titnom'
        },
        {
          title: 'PEC',
          data: 'pec'
        },
        {
          title: 'Radicado',
          data: 'grugru'
        },
        {
          title: 'Meses',
          data: 'PerTiempoTit'
        },
        {
          title: 'Fecha Inicio',
          data: 'cobini'
        },
        {
          title: 'Equilibrado'
        },
        {
          title: 'TC',
          render: (data,type,row,meta) => {
            let matches = data.match(/\b(\w)/g); // ['J','S','O','N']
						let acronym = matches.join('');
						return acronym;
          }
        }
      ]
    }
  }

  ngOnInit() {

    this._informe.InformacionContrato(this.data.fecha_inicio, this.data.fecha_final, this.data.id_titular).subscribe((dato:any) => {
      this.tableOpt = dato.resultado;
      this.dtTrigger.next();
    });

    let that = this;
    $("body").off().on("click",".titular_doc",(e)=>{
      e.stopPropagation();
      if (!e.target.hasAttribute("titular")) return;
      let titular:number = e.target.getAttribute('titular');
      that.dialog.open(BenefXTitularComponent, {
        data: {
          fecha_inicio: that.data.fecha_inicio,
          fecha_final: that.data.fecha_final,
          titular_id: titular
        }
      });
    });
  }

  public getEquilibrado(benMayores:number,benMenores:number,benIntermedio:number) {
    if(benMayores == 0 && benMenores == 0 && benIntermedio == 0){
      return "Cancelado";
    }else if((benMayores + benMenores) > benIntermedio){
      return "Descompensado";
    }else{
      return "Compensado";
    }
  }

  public guardarTitular(id_titular){ 
    this._informe.GuardarTitular(id_titular).subscribe((data:any) => {
      if(data.estatus == 1){
        this._snackBar.open('Se ha guardado el beneficiario', 'Aceptar', {
          duration: 2000,
        });
      }else if(data.estatus == 0){
        this._snackBar.open('Error al guardar el beneficiario', 'Aceptar', {
          duration: 2000,
        });
      } 
    })
  }

}

